export default __webpack_public_path__ + "static/media/credix_logo_zwart.5ad312ee.svg";